import React from 'react';

const EntityTagsList = ({ tags = [], size = 'sm', maxVisible = 4, className = '' }) => {
  if (!tags?.length) return null;

  const sizeClasses = {
    sm: 'text-[10px] px-2 py-0.5',
    md: 'text-xs px-2.5 py-1',
  };

  const visible = tags.slice(0, maxVisible);
  const hiddenCount = tags.length - visible.length;

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {visible.map((tag) => (
        <span
          key={tag.id}
          className={`inline-flex items-center rounded-full font-medium border shadow-sm ${sizeClasses[size] || sizeClasses.sm}`}
          style={{
            fontFamily: 'CustomFont',
            backgroundColor: tag.color ? `${tag.color}18` : undefined,
            borderColor: tag.color ? `${tag.color}55` : undefined,
            color: tag.color || undefined,
          }}
        >
          <span
            className="w-1.5 h-1.5 rounded-full ml-1.5 flex-shrink-0"
            style={{ backgroundColor: tag.color || '#1890ff' }}
          />
          {tag.name}
        </span>
      ))}
      {hiddenCount > 0 && (
        <span
          className={`inline-flex items-center rounded-full bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 ${sizeClasses[size] || sizeClasses.sm}`}
          style={{ fontFamily: 'CustomFont' }}
        >
          +{hiddenCount}
        </span>
      )}
    </div>
  );
};

export default EntityTagsList;
